import _pickBy from 'lodash/pickBy';

const globalSettingFilters = filters => {
  const { id, settingName, code, page, perPage, tag } = filters;

  const sanitizedFilters = {
    id,
    name: settingName,
    code,
    tagName: tag,
    page,
    perPage
  };

  return _pickBy(sanitizedFilters, filter => !!filter);
};

export default globalSettingFilters;
